module.exports = __webpack_public_path__ + "assets/images/slope-education/tablet.svg?v=effdb8fa";